<template>
    <div class="ppv2-space-y-4">
        <InfoMessageBox :title="$t('messageBox.invoiceFooter.start.title')" color="info" :customIcon="customIconStart" />
        <BaseTextarea
            v-model="formData.invoice_footer_text"
            :label="$t('invoiceFooter.fields.footerText.label')"
            :placeholder="$t('invoiceFooter.fields.footerText.placeholder')"
            :tooltipMsg="$t('invoiceFooter.fields.footerText.infoMessage')"
            :useEditor="true"
        />
    </div>
</template>

<script>
import InfoMessageBox from '../../../Shared/InfoMessageBox.vue'
import BaseTextarea from '../../../Shared/BaseTextarea.vue'

export default {
    name: 'InvoiceFooter',
    components: {
        InfoMessageBox,
        BaseTextarea,
    },
    data() {
        return {
            customIconStart: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 3.5V7.5C15 8.03043 15.2107 8.53914 15.5858 8.91421C15.9609 9.28929 16.4696 9.5 17 9.5H21M16 3.5H5C4.46957 3.5 3.96086 3.71071 3.58579 4.08579C3.21071 4.46086 3 4.96957 3 5.5V19.5C3 20.0304 3.21071 20.5391 3.58579 20.9142C3.96086 21.2893 4.46957 21.5 5 21.5H19C19.5304 21.5 20.0391 21.2893 20.4142 20.9142C20.7893 20.5391 21 20.0304 21 19.5V8.5L16 3.5Z" stroke="#021832" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
            formData: {
                invoice_footer_text: '',
            },
        }
    },
    computed: {
        establishment() {
            return this.$store.getters['establishment/establishment']
        },
    },
    watch: {
        establishment: {
            handler() {
                this.initializeForm()
            },
            immediate: true,
            deep: true,
        },
        formData: {
            handler(newVal) {
                this.$emit('update', newVal)
            },
            deep: true,
        },
    },
    methods: {
        initializeForm() {
            const fields = ['invoice_footer_text']
            fields.forEach((field) => {
                if (this.establishment.hasOwnProperty(field)) {
                    this.formData[field] = this.establishment[field]
                }
            })
        },
    },
}
</script>

<style scoped></style>
